import { type VendorDataItem } from "../../../gql-generated/types";

import { RangeModifier } from "./RangeModifier";

export class Connection {
    readonly vendorData: readonly VendorDataItem[] = [];
    readonly priority: number = 0;
    readonly scheduleRange = new RangeModifier();
}
